import React from 'react';
import { Navbar, Divider } from '@blueprintjs/core';
import Logo from '../../assets/logo-icon.svg';

function ErrorNavbar() {
  return (
    <React.Fragment>
      <Navbar className="navbar">
        <Navbar.Group>
          <Navbar.Heading
            className="navbar__logo__container"
            style={{ margin: '0.714em' }}
          >
            <img src={Logo} />
            <h3>Catalogue Studio</h3>
          </Navbar.Heading>
        </Navbar.Group>
      </Navbar>
      <Divider className="navbar__divider" />
    </React.Fragment>
  );
}

export default ErrorNavbar;
